var _path, _circle, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarManualParts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4504 20.7444C25.997 20.2793 25.4272 20.0467 24.7645 20.0467H16.6253L14.2068 19.1979L14.5905 18.105L16.6253 18.884H19.881C20.2879 18.884 20.6135 18.7212 20.8809 18.4538C21.1483 18.1864 21.2762 17.8608 21.2762 17.5003C21.2762 16.8725 20.9739 16.4423 20.3693 16.1981L11.9162 13.0703H9.64885V23.535L17.788 25.8604L27.1248 22.3722C27.1364 21.756 26.9039 21.2095 26.4504 20.7444ZM7.32337 13.0703H2.65381V25.8604H7.32337V13.0703Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5846,
    cy: 8.5958,
    r: 6.24619,
    fill: "#00C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9901 9.48816L21.6926 4.13428H23.4773L23.3285 6.81122L23.1798 9.48816H21.9901Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6926,
    y: 11.2725,
    width: 1.78463,
    height: 1.78463,
    rx: 0.892313,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarManualParts);
export default __webpack_public_path__ + "static/media/icon-car-manual-parts.bd9d68ac9c7753181e4f183f326a8d1d.svg";
export { ForwardRef as ReactComponent };